export const FileFieldTypes = {
  DOCUMENT: ['image/png', 'image/jpeg'],
  IMAGE: [
    'image/png',
    'image/jpeg',
    'image/heic',
    'text/plain',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ],
  OTHER: ['application/zip', 'application/vnd.rar', 'application/x-7z-compressed'],
}
